/**
 * Helpers de exibição de `TenantMember`.
 *
 * Ficam em `utils/` (e não no hook `useTenantMembers`) para que componentes
 * puramente de apresentação — `LeadCard`, `LeadAssigneeSelect` — possam usá-los
 * sem arrastar junto a instância Axios de `services/api`.
 *
 * ⚠️ Um `TenantMember` carrega três ids distintos:
 *   - `m.id`     → id do `TenantMember` (é o que `ChatSession.assignedToId` usa)
 *   - `m.userId` → id do `User`         (é o que `Lead.assignedTo` usa)
 *   - `m.user`   → `{ id, name, email, avatarUrl }`
 */

/** Nome de exibição, com degradação para e-mail e depois para rótulo genérico. */
export function memberDisplayName(member) {
  return member?.user?.name || member?.user?.email || "Membro da equipe";
}

/** Iniciais (1–2 letras) do membro, para o avatar compacto do card. */
export function memberInitials(member) {
  const parts = memberDisplayName(member).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}
